import axiosPrivate from "./axiosPrivate";

const getCajaFinancieroContabilidad = (perfil_id, periodo_fecha) => {
    return axiosPrivate.post("getCajaFinancieroContabilidad", {
        perfil_id,
        periodo_fecha
    }).then(response => response.data);
};

const updateCajaContabilidadSaldoInicial = (data) => {
    return axiosPrivate.post("updateCajaContabilidadSaldoInicial", data)
        .then(response => response.data);
};

const insertCajaFinancieroContabilidad = (data) => {
    return axiosPrivate.post("insertCajaFinancieroContabilidad", data)
        .then(response => response.data);
};

const updateCajaFinancieroContabilidad = (data) => {
    return axiosPrivate.post("updateCajaFinancieroContabilidad", data)
        .then(response => response.data);
};

const deleteCajaFinancieroContabilidad = (data) => {
    return axiosPrivate.post("deleteCajaFinancieroContabilidad", data)
        .then(response => response.data);
};

export default {
    getCajaFinancieroContabilidad,
    updateCajaContabilidadSaldoInicial,
    insertCajaFinancieroContabilidad,
    updateCajaFinancieroContabilidad,
    deleteCajaFinancieroContabilidad
};
